import { render } from "./BloodDrawMedia.vue?vue&type=template&id=2b9bbf94&scoped=true"
import script from "./BloodDrawMedia.vue?vue&type=script&lang=js"
export * from "./BloodDrawMedia.vue?vue&type=script&lang=js"

import "./BloodDrawMedia.vue?vue&type=style&index=0&id=2b9bbf94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9bbf94"]])

export default __exports__